// Copyright © 2023 CATTLEytics Inc.

export const scrollToTop = (): void =>
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
